<template>
  <div v-if="!loading" class="settings-nav">
    <Button
      v-if="!locked"
      class="sm link nav-button nav-button-remove"
      :loading="removing"
      @click="onRemoveClick"
    >
      {{ removing ? "Removing" : "Remove" }}
    </Button>

    <Button
      class="sm secondary ml-auto"
      :loading="saving"
      @click="$emit('save')"
    >
      {{ saving ? "Saving" : "Save section" }}
    </Button>
  </div>
</template>

<script>
export default {
  name: "SettingsNav",

  props: {
    loading: {
      default: false,
      type: Boolean,
    },
    locked: {
      default: false,
      type: Boolean,
    },
    removing: {
      default: false,
      type: Boolean,
    },
    saving: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    onRemoveClick() {
      // Show an alert to warn the user...
      this.$modal.show("dialog", {
        title: "📛 Confirm Deletion 📛",
        text:
          "This will remove the section and it's settings. Are you sure you want to continue?",
        buttons: [
          {
            title: "Yes",
            class: "vue-dialog-button bg-danger hover:bg-brand",
            handler: () => {
              this.$modal.hide("dialog");
              this.$emit("remove");
            },
          },
          {
            title: "Cancel",
            class: "vue-dialog-button bg-support-light hover:bg-support",
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.settings-nav {
  @apply flex border bg-grey-lightest py-2 px-4 shadow rounded-lg p-4 mt-6 mb-4;

  @screen md {
    @apply mb-6;
  }
}

.nav-button {
  @apply p-0 px-2 font-light font-sans no-underline;

  &:hover {
    @apply underline;
  }
}

.nav-button-remove {
  @apply text-danger px-0 text-sm;
}

.nav-icon {
}
</style>
